import { StyleCard, StyleCardHeader } from './style'
import Skeleton from '@components/skeleton'

const InstantAppointmentQueueCardLoader = () => {
  return (
    <StyleCard>
      <StyleCardHeader>
        <Skeleton width={60} height={60} radius={30} />
        <Skeleton width={30} height={30} radius={15} />
      </StyleCardHeader>
      <Skeleton width={'100%'} height={40} radius={8} />
    </StyleCard>
  )
}

export default InstantAppointmentQueueCardLoader
